module.exports = "/static/assets/54163bf1a436b31987f4f31334efe649.png";